import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice.ts";
import EstateBadge from "@/domains/estate/components/EstateBadge";

type Props = {
  name: string;
  onClick: () => void;
  image: string;
  price: number;
  isActive: boolean;
};

export default function EstateDesignVariantPreview({
  price,
  name,
  onClick,
  image,
  isActive,
}: Props) {
  const { t } = useTranslation("estate");

  return (
    <button
      type="button"
      className="group relative h-[10.5rem] flex items-center gap-5 p-2.5 bg-dark-800 rounded-[0.75rem]"
      onClick={onClick}
    >
      <div className="absolute top-0 left-0 size-full bg-[linear-gradient(99deg,rgba(215,52,52,0.5)_0%,transparent_40.69%)] rounded-[0.75rem] opacity-0 transition-all duration-200 ease-in-out pointer-events-none group-hover:opacity-100" />
      <div
        className="relative z-1 h-[9.25rem] w-[14.375rem] rounded-[0.625rem] shrink-0"
        style={{
          backgroundImage: `url(${image})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {isActive && (
          <EstateBadge
            name="checked"
            text={t("estate.purchased")}
            className="absolute top-2.5 left-2.5 w-[6.4375rem] bg-[linear-gradient(90deg,rgba(33,101,44,0.3)_0%,rgba(18,18,18,0)_100%)] bg-[rgba(18,18,18,0.4)]"
            classNameIcon="w-3.5 h-2.5 bg-[#84FF97]"
            classNameText="text-12"
          />
        )}
      </div>
      <div className="relative z-1 grow h-full flex flex-col gap-1">
        <div className="text-white text-16 font-bold text-left line-clamp-1">
          {t(`estate.design.designVariants.${name}.title`)}
        </div>
        <div className="text-gray/50 text-15 font-medium text-left line-clamp-4">
          {t(`estate.design.designVariants.${name}.description`)}
        </div>
        <div className="text-16 font-bold text-left text-[#FF4E4E] mt-auto">
          {formatPrice(price)} ₽
        </div>
      </div>
    </button>
  );
}
